import { formatTime } from '@seedplanner/shared-utils';
// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { useUserContext } from '../../context/UserContext';
import { formatNumber } from '../../utils/formatNumber';
import { Table } from '../common/table';
import type { ColumnType } from '../common/table/Table';
import { PlantingGroupIdLink } from '../plantingGroup';

export interface PlantingData {
  readonly plantingId: string;
  readonly trays: number;
  readonly plantedAtTime?: number;
  readonly harvestTime: number;
}

interface Props {
  readonly plantings: readonly PlantingData[];
}

export default function TaskPlantingGroupTable({ plantings }: Props) {
  const { timezone, language } = useUserContext();
  const plantingLinks: React.ReactElement[] = [];
  const traysValues: string[] = [];
  const plantedAtTimes: string[] = [];
  const harvestTimes: string[] = [];
  for (const planting of plantings) {
    plantingLinks.push(<PlantingGroupIdLink id={planting.plantingId} />);
    traysValues.push(formatNumber(planting.trays, language));
    plantedAtTimes.push(
      planting.plantedAtTime === undefined ? '-' : formatTime(planting.plantedAtTime, { timezone, time: true }),
    );
    harvestTimes.push(formatTime(planting.harvestTime, { timezone }));
  }
  const columns: ColumnType[] = [
    {
      name: 'Planting',
      values: plantingLinks,
    },
    {
      name: 'Trays',
      values: traysValues,
      numeric: true,
    },
    {
      name: 'Planted At',
      values: plantedAtTimes,
      visibleAt: 'sm',
    },
    {
      name: 'Harvest Date',
      values: harvestTimes,
    },
  ];

  return <Table columns={columns} />;
}
